export default __webpack_public_path__ + "static/media/circle-bg.9cd8ebd7.svg";